/** User-selectable pipeline stages (MVP — keeps dropdown small). */
export const USER_STATUS_OPTIONS = [
  { value: 'saved', label: 'Saved' },
  { value: 'resume_generated', label: 'Ready', requiresResume: true },
  { value: 'applied', label: 'Applied' },
  { value: 'interviewing', label: 'Interview' },
  { value: 'offer', label: 'Offer' },
  { value: 'rejected', label: 'Passed' },
  { value: 'skipped', label: 'Skipped' },
];

const LABELS = {
  saved: 'Saved',
  resume_generated: 'Ready',
  applied: 'Applied',
  interviewing: 'Interview',
  offer: 'Offer',
  rejected: 'Passed',
  skipped: 'Skipped',
};

/** Normalize display value when backend still has `saved` but resume exists. */
export function effectiveStatus(job) {
  if (!job) return 'saved';
  const status = job.status || 'saved';
  if (job.hasResume && status === 'saved') {
    return 'resume_generated';
  }
  return status;
}

export function statusLabel(status) {
  return LABELS[status] || 'Saved';
}

export function statusOptionsForJob(job) {
  return USER_STATUS_OPTIONS.map((opt) => ({
    ...opt,
    disabled: !!(opt.requiresResume && !job?.hasResume),
  }));
}

/** Bucket jobs for pipeline / Sankey snapshot. */
export function pipelineBuckets(jobs = []) {
  const buckets = {
    saved: 0,
    ready: 0,
    applied: 0,
    interviewing: 0,
    offer: 0,
    passed: 0,
    skipped: 0,
  };

  for (const job of jobs) {
    const s = effectiveStatus(job);
    if (s === 'applied') {
      buckets.applied += 1;
    } else if (s === 'interviewing') {
      buckets.interviewing += 1;
    } else if (s === 'offer') {
      buckets.offer += 1;
    } else if (s === 'rejected') {
      buckets.passed += 1;
    } else if (s === 'skipped') {
      buckets.skipped += 1;
    } else if (s === 'resume_generated' || (job.hasResume && s === 'saved')) {
      buckets.ready += 1;
    } else {
      buckets.saved += 1;
    }
  }

  return buckets;
}

export const PIPELINE_STAGES = [
  { key: 'saved', label: 'Saved' },
  { key: 'ready', label: 'Resume ready' },
  { key: 'applied', label: 'Applied' },
  { key: 'interviewing', label: 'Interview' },
  { key: 'offer', label: 'Offer' },
  { key: 'passed', label: 'Passed' },
];
